/**
 * KAN-944: сигнал "запрос к API вернул 404" (url запроса). Ответы разбирает
 * перехватчик apiClient, слушатели (например, useClientAccess) сами решают,
 * относится ли url к ним. Одно место на все запросы: GET, PATCH, POST.
 */
type Listener = (url: string) => void;

const listeners = new Set<Listener>();

export function onApiNotFound(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifyApiNotFound(url: string): void {
  listeners.forEach((listener) => {
    try {
      listener(url);
    } catch {
      // Слушатель упал: остальные и сам запрос не страдают.
    }
  });
}
